import { Button } from "@dune/ui";
import { CheckCircle } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const DocuSignComplete = () => {
	const [searchParams] = useSearchParams();
	const event = searchParams.get("event");
	const [countdown, setCountdown] = useState(5);

	const closeModal = useCallback(() => {
		if (window.parent !== window) {
			window.parent.postMessage(
				{ type: "docusign_signing_complete" },
				window.location.origin,
			);
		}
	}, []);

	useEffect(() => {
		if (window.parent !== window && event === "signing_complete") {
			closeModal();
		}
	}, [event, closeModal]);

	useEffect(() => {
		// Countdown automatique
		const timer = setInterval(() => {
			setCountdown((prev) => {
				if (prev <= 1) {
					closeModal();
					return 0;
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(timer);
	}, [closeModal]);

	return (
		<div className="flex items-center justify-center min-h-screen bg-gray-50 p-4">
			<div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
				<div className="flex justify-center mb-6">
					<CheckCircle className="h-16 w-16 text-green-500" />
				</div>

				<h1 className="text-2xl font-bold text-gray-900 mb-4">
					Signature terminée
				</h1>

				<p className="text-gray-600 mb-6">
					La signature du document a été complétée avec succès.
				</p>

				<p className="text-sm text-gray-500 mb-6">
					Cette fenêtre se fermera automatiquement dans {countdown} seconde
					{countdown > 1 ? "s" : ""}
				</p>

				<Button onClick={closeModal} className="w-full">
					Fermer maintenant
				</Button>
			</div>
		</div>
	);
};

export default DocuSignComplete;
